import Vue from 'vue'
import VueRouter from 'vue-router'
import featureFlags from 'src/services/featureFlags.service'

/** Basic **/
const pageHome = () =>
  import(
    /* webpackChunkName: "home" */
    /* webpackPreload: true */
    'theme/pages/page-home.vue'
  )
const page404 = () =>
  import(/* webpackChunkName: "page-404" */ 'theme/page-404.vue')
const clientServicesPage = () =>
  import(
    /* webpackChunkName: "client-services" */ 'theme/page-new-client-services.vue'
  )
const aboutPage = () =>
  import(/* webpackChunkName: "about" */ 'theme/page-about-us.vue')
const pageCareers = () =>
  import(/* webpackChunkName: "page-careers" */ 'theme/page-careers.vue')
const pageContacts = () =>
  import(/* webpackChunkName: "page-contacts" */ 'theme/page-contacts.vue')
const pageLegalNotices = () =>
  import(/* webpackChunkName: "legal-notices" */ 'theme/page-legal-notices.vue')
const pageProjectsTerms = () =>
  import(
    /* webpackChunkName: "projects-terms" */ 'theme/pages/page-corpdocs-solutions.vue'
  )
const pageProjectsNotifications = () =>
  import(
    /* webpackChunkName: "projects-notifications" */ 'theme/components/projects/page-projects-notifications.vue'
  )
const pageDealHistorySolutions = () =>
  import(
    /* webpackChunkName: "dealhistory-solutions" */ 'theme/pages/page-dealhistory-solutions.vue'
  )

/** Storyblok **/
const blokRoot = () =>
  import(/* webpackChunkName: "home" */ 'theme/components/blok/blok-root.vue')
const pageStoryblokListing = () =>
  import(
    /* webpackChunkName: "storyblok-listing" */ 'theme/page-storyblok-listing.vue'
  )

/** Search **/
const pageSearch = () =>
  import(/* webpackChunkName: "search" */ 'theme/page-search.vue')
const pageMyCompanies = () =>
  import(/* webpackChunkName: "favorites" */ 'theme/page-my-companies.vue')
const pageCompanyProfile = () =>
  import(
    /* webpackChunkName: "company-profile" */ 'theme/components/profile-page/company-profile-page.vue'
  )
const pagePersonProfile = () =>
  import(
    /* webpackChunkName: "person-profile" */ 'theme/components/profile-page/person-profile-page.vue'
  )
const pageProjectProfile = () =>
  import(
    /* webpackChunkName: "project-profile" */ 'theme/components/profile-page/project-profile-page.vue'
  )
const pageAssociationProfile = () =>
  import(
    /* webpackChunkName: "association-profile" */ 'theme/components/profile-page/association-profile-page.vue'
  )

/** Projects  **/
const pageInvite = () =>
  import(/* webpackChunkName: "invite" */ 'components/invite/page-invite.vue')
const pageProjects = () =>
  import(/* webpackChunkName: "projects" */ 'theme/page-projects.vue')
const pageProjectResults = () =>
  import(
    /* webpackChunkName: "project-results" */ 'components/projects/page-project-results'
  )
const pageProjectCorpRegistryFiling = () =>
  import(
    /* webpackChunkName: "project-corp-registry" */ 'components/projects/page-corp-registry-filing.vue'
  )
const pageProjectCustomResearch = () =>
  import(
    /* webpackChunkName: "project-custom-research" */ 'components/projects/page-project-custom-research.vue'
  )

/** Dealbook **/
const pageDealbookLanding = () =>
  import(
    /* webpackChunkName: "dealbook-landing" */ 'theme/pages/page-dealbook-landing.vue'
  )
const pageDealbookPlatform = () =>
  import(
    /* webpackChunkName: "dealroom-platform" */ 'theme/components/dealbook/dealbook-platform.vue'
  )
const pageDealbookSubmit = () =>
  import(
    /* webpackChunkName: "dealroom-submit" */ 'theme/components/dealbook/dealbook-submit-page.vue'
  )
const pageDealbookList = () =>
  import(
    /* webpackChunkName: "dealroom-submit" */ 'theme/components/dealbook/dealbook-list-page.vue'
  )
const pageSubmitProposal = () =>
  import(
    /* webpackChunkName: "submit-proposal" */ 'theme/components/proposals/submit-proposal-page.vue'
  )

/** Matching **/
const pageInvestmentOpportunities = () =>
  import(
    /* webpackChunkName: "investment-opportunities" */ 'theme/components/matching/investment-opportunities-page.vue'
  )
const pageInitiativeClosed = () =>
  import(
    /* webpackChunkName: "initiative-closed" */ 'theme/components/matching/initiative-closed-page.vue'
  )
const pageEthics1st = () =>
  import(
    /* webpackChunkName: "ethics-1st" */ 'theme/components/matching/cipe-page.vue'
  )

const pageEthics1stSubmit = () =>
  import(
    /* webpackChunkName: "ethics-1st" */ 'theme/components/matching/cipe-submit-page.vue'
  )

/** DIT **/
const pageDITInvestor = () =>
  import(
    /* webpackChunkName: "dit-investor" */ 'theme/components/dit/dit-investor-page.vue'
  )
const pageDITInvestorSubmit = () =>
  import(
    /* webpackChunkName: "dit-investor-submit" */ 'theme/components/dit/dit-submit-page.vue'
  )
const pageInvestor = () =>
  import(
    /* webpackChunkName: "dit-investor" */ 'theme/components/afdb/investor-page.vue'
  )

/** WATIH **/
const pageWATIHInvestor = () =>
  import(
    /* webpackChunkName: "dit-investor" */ 'theme/components/watih/investor-page.vue'
  )

/** GabonInvest **/
const pageGabonInvestorSubmit = () =>
  import(
    /* webpackChunkName: "gabon-investor-submit" */ 'theme/components/gabon-invest/submit-page.vue'
  )

const pageGabonInvestor = () =>
  import(
    /* webpackChunkName: "gabon-investor" */ 'theme/components/gabon-invest/investor-page.vue'
  )

/** Account **/
const pageUserProfile = () =>
  import(
    /* webpackChunkName: "user-profile" */ 'theme/pages/page-user-profile.vue'
  )
const pageUserCompanies = () =>
  import(
    /* webpackChunkName: "user-companies" */ 'theme/components/account/my-companies-page.vue'
  )

/** Admin **/
const pageAdmin = () =>
  import(/* webpackChunkName: "page-admin" */ 'theme/page-admin')
const pageFeatureFlag = () =>
  import(/* webpackChunkName: "feature-flag" */ 'theme/page-feature-flag')
const pageNewsMain = () =>
  import(/* webpackChunkName: "news-main" */ 'theme/page-news-main.vue')

Vue.use(VueRouter)

const routerOptions = {
  mode: 'history',
  linkActiveClass: 'is-active',
  base: __dirname,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
      }
    } else {
      return { y: 0 }
    }
  },
  routes: [
    // Search routes
    { path: '/search', redirect: '/data/search/companies' },
    { path: '/search/:kind', redirect: '/data/search/:kind' },
    {
      path: '/data/favorites',
      component: pageMyCompanies,
      meta: { minfooter: true, sidebar: true },
    },
    {
      path: '/data/favorites/recoverpassword',
      redirect: '/profile/recover-password',
    },
    { path: '/data/search', redirect: '/data/search/companies' },
    {
      path: '/data/search/:kind',
      component: pageSearch,
      meta: { minfooter: true, sidebar: true },
    },
    {
      path: '/data/company/:name/:id',
      name: 'companyProfileNew',
      component: pageCompanyProfile,
      meta: { minfooter: true },
    },
    {
      path: '/data/person/:name/:id',
      name: 'personProfileNew',
      component: pagePersonProfile,
      meta: { minfooter: true },
    },
    {
      path: '/data/project/:name/:id',
      name: 'projectProfileNew',
      component: pageProjectProfile,
      meta: { minfooter: true },
    },
    {
      path: '/data/association/:name/:id',
      name: 'associationProfileNew',
      component: pageAssociationProfile,
      meta: { minfooter: true },
    },
    // Storyblok routes
    { path: '/insights/:folder', component: pageStoryblokListing },
    { path: '/content/:type/:slug', component: blokRoot },
    // Dealroom routes
    {
      path: '/deals/find-funding',
      redirect: '/about/deals',
    },
    {
      path: '/deals/find-funding/:id',
      redirect: '/about/deals',
    },
    {
      path: '/deals/source-deals',
      redirect: '/about/deals',
    },
    // Dealbook routes
    {
      path: '/about/deals',
      component: pageDealbookLanding,
      meta: { flag: 'dealbook' },
    },
    {
      path: '/deals/submit',
      name: 'dealbookSubmissions',
      component: pageDealbookList,
      props: true,
      meta: { flag: 'dealbook' },
    },
    {
      path: '/deals/submissions',
      name: 'dealbookSubmissionsList',
      component: pageDealbookList,
      props: true,
      meta: { flag: 'dealbook', sidebar: true },
    },
    {
      path: '/deals/submit/:id',
      name: 'dealbookSubmit',
      component: pageDealbookSubmit,
      props: true,
      meta: { flag: 'dealbook', minheader: true },
    },
    {
      path: '/deals/platforms/:id',
      name: 'dealbook-platform',
      component: pageDealbookPlatform,
      meta: { flag: 'dealbook' },
    },
    {
      path: '/proposals/submit',
      component: pageSubmitProposal,
      meta: { minfooter: true, minheader: true },
    },
    {
      path: '/proposals/future',
      redirect: '/proposals/submit',
    },
    // Matching
    {
      path: '/matching/marketplaces',
      component: pageInvestmentOpportunities,
    },
    {
      path: '/matching/initiative-closed',
      component: pageInitiativeClosed,
    },
    {
      path: '/matching/ethics-1st',
      component: pageEthics1st,
      meta: { flag: 'cipe' },
    },
    {
      path: '/matching/ethics-1st/settings',
      component: pageEthics1stSubmit,
      meta: { flag: 'cipe' },
    },
    // DIT
    {
      path: '/deals/dit/investor',
      name: 'DITInvestor',
      component: pageDITInvestor,
      props: true,
      meta: { flag: 'dit' },
    },
    {
      path: '/deals/dit/investor/submit',
      name: 'DITInvestorSubmit',
      component: pageDITInvestorSubmit,
      props: true,
      meta: { flag: 'dit' },
    },
    // AYAF
    {
      path: '/deals/afdb/investor',
      name: 'Investor',
      component: pageInvestor,
      props: true,
      meta: { flag: 'dit' },
    },
    {
      path: '/deals/afdb/investor/submit',
      redirect: '/deals/afdb/investor',
      props: true,
      meta: { flag: 'dit' },
    },
    // WATIH investor
    {
      path: '/deals/watih/investor',
      name: 'WATIHInvestor',
      component: pageWATIHInvestor,
      props: true,
      meta: { flag: 'watih' },
    },
    {
      path: '/deals/watih/investor/submit',
      redirect: '/deals/watih/investor',
    },
    // Gabon-invest
    {
      path: '/deals/gabon-virtual-dealroom/investor',
      name: 'GabonInvest',
      component: pageGabonInvestor,
      props: true,
    },
    {
      path: '/deals/gabon-virtual-dealroom/investor/submit',
      name: 'GabonInvestSubmit',
      component: pageGabonInvestorSubmit,
      props: true,
    },
    // Flags routes
    { path: '/flags', component: pageAdmin },
    { path: '/set-flag/:flag', component: pageFeatureFlag },
    // Projects routes
    {
      path: '/projects',
      component: pageProjects,
      meta: { flag: 'projects', minfooter: true, sidebar: true },
    },
    {
      path: '/projects/settings',
      component: pageProjectsNotifications,
      meta: { flag: 'projects', minfooter: true, sidebar: true },
    },
    {
      path: '/projects/corp-registry-filing',
      name: 'corpRegistryFiling',
      component: pageProjectCorpRegistryFiling,
      props: true,
      meta: { flag: 'projects', minfooter: true },
    },
    {
      path: '/projects/custom-research',
      name: 'dealHistory',
      component: pageProjectCustomResearch,
      props: true,
      meta: { minfooter: true },
    },
    {
      path: '/project/:id',
      name: 'project-results',
      component: pageProjectResults,
      props: true,
      meta: { flag: 'projects', minfooter: true },
    },
    // Account
    {
      path: '/profile/recover-password',
      component: pageUserProfile,
      props: true,
      meta: { minfooter: true, sidebar: true },
    },
    {
      path: '/profile',
      name: 'user-profile',
      component: pageUserProfile,
      props: true,
      meta: { minfooter: true, sidebar: true },
    },
    {
      path: '/my-companies',
      name: 'myCompaniesPage',
      component: pageUserCompanies,
      props: true,
      meta: { sidebar: true, flag: 'futureInterest' },
    },
    // About
    { path: '/client-services', redirect: '/about/solutions' },
    {
      path: '/about/solutions/market-map',
      redirect: '/about/solutions',
    },
    {
      path: '/about/solutions',
      component: clientServicesPage,
      name: 'solutions-page',
    },
    {
      path: '/about/solutions/corporate-documents',
      component: pageProjectsTerms,
      meta: { flag: 'projects' },
    },
    {
      path: '/about/solutions/deal-history',
      component: pageDealHistorySolutions,
      meta: { flag: 'dealHistory' },
    },
    {
      path: '/about/contact',
      component: pageContacts,
    },
    {
      path: '/about/careers',
      component: pageCareers,
    },
    {
      path: '/about/legal',
      component: pageLegalNotices,
    },
    {
      path: '/about/team',
      component: aboutPage,
    },
    // Legacy routes
    { path: '/invite/:id', component: pageInvite },
    { path: '/news', component: pageNewsMain },
    // Basic routes
    { path: '/register', component: pageHome },
    { path: '/password-recovery', component: pageHome },
    { path: '/404', component: page404 },
    { path: '/404/:type', component: page404 },
    { path: '*', redirect: '/404' },
    { path: '/', name: 'Home', component: pageHome },
  ],
}

// Check IE and Edge browsers and disabling scrollBehavior for them
// (workaround for the issue with routing and GTM)
if (
  /Edge\/\d./i.test(navigator.userAgent) ||
  navigator.userAgent.match(/Trident.*rv:11\./)
) {
  delete routerOptions.scrollBehavior
}

const router = new VueRouter(routerOptions)

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.flag)) {
    const isStoryblok = to.query._storyblok
    const isEnabled = isStoryblok
      ? featureFlags.isEnabledForStoryblok(to.meta.flag)
      : featureFlags.isEnabled(to.meta.flag)
    if (isEnabled) {
      next()
    } else {
      next({ path: '/404' })
    }
  } else {
    next()
  }
})

export default router
